import { Controller } from "stimulus";

export default class WaveformController extends Controller {
  static values = {
    seed: Number,
    barWidth: { type: Number, default: 2 },
    gapWidth: { type: Number, default: 2 },
    minHeight: { type: Number, default: 20 },
    maxHeight: { type: Number, default: 100 }
  };

  connect() {
    this.element.style.overflow = 'hidden';
    this.element.style.minWidth = '0';

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.generateWaveform();
      });
      this.resizeObserver.observe(this.element);
    }

    this.generateWaveform();
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  // Simple seeded pseudo-random number generator
  seededRandom(seed) {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }

  generateWaveform() {
    const seed = this.seedValue || 1;
    const minHeight = this.minHeightValue;
    const maxHeight = this.maxHeightValue;
    const barWidth = this.barWidthValue;
    const gapWidth = this.gapWidthValue;
    
    // Clear any existing content
    this.element.innerHTML = '';
    
    // Get container width and calculate how many bars fit
    const containerWidth = this.element.offsetWidth;
    const barCount = Math.floor(containerWidth / (barWidth + gapWidth));
    
    // Create container div
    const container = document.createElement('div');
    container.className = 'flex items-center overflow-hidden gap-[2px] h-20';
    
    // Generate bars with deterministic heights
    for (let i = 0; i < barCount; i++) {
      const randomValue = this.seededRandom(seed + i);
      const heightPercent = minHeight + (randomValue * (maxHeight - minHeight));
      
      const bar = document.createElement('div');
      bar.className = 'w-[2px] bg-accent opacity-60 rounded-full';
      bar.style.height = `${heightPercent}%`;
      
      container.appendChild(bar);
    }
    
    this.element.appendChild(container);
  }
}
